var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.19507 1.42697L7.12886 8.17069L0.19507 14.9144C0.0709257 15.0349 0.00142309 15.1966 0.00142309 15.3651C0.00142309 15.5335 0.0709257 15.6953 0.19507 15.8157C0.255363 15.8741 0.327327 15.9204 0.40675 15.9521C0.486173 15.9837 0.571458 16 0.657608 16C0.743758 16 0.829041 15.9837 0.908464 15.9521C0.987887 15.9204 1.05985 15.8741 1.12014 15.8157L8.49797 8.64159C8.6275 8.5156 8.7 8.34663 8.7 8.17069C8.7 7.99476 8.6275 7.82578 8.49797 7.69979L1.12157 0.525651C1.06123 0.466899 0.989089 0.420202 0.909403 0.388316C0.829717 0.356431 0.744101 0.340003 0.657608 0.340003C0.571115 0.340003 0.485498 0.356431 0.405812 0.388316C0.326126 0.420202 0.253984 0.466899 0.193647 0.525651C0.0695019 0.646133 0 0.807883 0 0.976314C0 1.14474 0.0709257 1.30649 0.19507 1.42697Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowN);
export default __webpack_public_path__ + "static/media/right_arrow_N.3475dd5399297b2114bc9c96946f3c43.svg";
export { ForwardRef as ReactComponent };